import { moduleProviderFactory } from 'core/providers';
import { Alerts } from './pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.alerts',
				pattern: '/alerts',
				isPrivate: true,
				authorization: ['platformSection.full'],
				children: [
					{
						name: 'master.app.main.alerts',
						pattern: '',
						component: Alerts,
					},
				],
			},
		],
	});
})();
